export const dsConfigSchemaSnippet =
`{
  "$schema": "https://json-schema.org/draft/2019-09/schema",
  "$id": "https://nca-3ds-ds.extranet.netcetera.biz/ds-config-schema/0.1.0",
  "title": "Netcetera 3DS Directory Server Configuration",
  "type": "object",
  "properties": {
    "system-config": {
      "type": "object",
      "properties": {
        "scheme-short-name": {
          "type": "string",
          "description": "Short name of the payment scheme."
        },
        "ds-reference-number": {
          "type": "string",
          "description": "Unique identifier assigned to the directory server by the EMVCo secretariat upon testing and approval."
        },
        "ds-url": {
          "type": "string",
          "format": "uri",
          "description": "Public URL of the directory server to which the ACS will send the RReq if a challenge occurs."
        },
        "device-info-decryption-rsa-key-id": {
          "type": "string",
          "description": "RSA key id of fallback key used for device-info decryption."
        },
        "device-info-decryption-ec-key-id": {
          "type": "string",
          "description": "EC key id of fallback key used for device-info decryption."
        }
      },
      "required": [
        "scheme-short-name",
        "ds-reference-number",
        "device-info-decryption-rsa-key-id",
        "device-info-decryption-ec-key-id"
      ],
      "additionalProperties": false
    },
    "three-ds-servers": {
      "type": "object",
      "$ref": "#/$defs/three-ds-servers-container",
      "description": "Participating 3DS Servers."
    },
    "sdks": {
      "type": "object",
      "$ref": "#/$defs/sdks-container",
      "description": "Participating 3DS SDKs."
    },
    "bin-ranges": {
      "type": "array",
      "description": "Participating card BIN ranges.",
      "items": {
        "type": "object",
        "properties": {
          "start-range": {
            "type": "integer",
            "description": "Start of the card BIN range.",
            "minimum": 0,
            "maximum": 9999999999999999999,
            "existingJavaType" : "java.math.BigInteger"
          },
          "end-range": {
            "type": "integer",
            "description": "End of the card BIN range.",
            "existingJavaType" : "java.math.BigInteger",
            "minimum": 0,
            "maximum": 9999999999999999999
          },
          "acs": {
            "type": "object",
            "$ref": "#/$defs/acs"
          }
        },
        "required": [
          "start-range",
          "end-range",
          "acs"
        ]
      }
    }
  },
  "required": [
    "system-config",
    "sdks",
    "three-ds-servers"
  ],
  "$defs": {
    "sdks-container": {
      "type": "object",
      "additionalProperties": {
        "type": "object",
        "$ref": "#/$defs/sdk"
      }
    },
    "sdk": {
      "type": "object",
      "properties": {
        "reference-numbers": {
          "type": "array",
          "description": "Set of unique identifiers assigned to the 3DS SDK by the EMVCo secretariat upon testing and approval.",
          "items": {
            "type": "string",
            "description":  "Unique identifier assigned to the 3DS SDK by the EMVCo secretariat upon testing and approval."
          },
          "minItems": 1,
          "uniqueItems": true
        }
      },
      "required": [
        "reference-numbers"
      ]
    },
    "acs": {
      "type": "object",
      "properties": {
        "reference-numbers": {
          "type": "array",
          "description": "Set of unique identifier assigned to the ACS by the EMVCo secretariat upon testing and approval",
          "items": {
            "type": "string",
            "description": "Unique identifier assigned to the ACS by the EMVCo secretariat upon testing and approval."
          },
          "minItems": 1,
          "uniqueItems": true
        },
        "areq-urls": {
          "type": "array",
          "description": "List of ACS URLs the directory server sends a 3DS authentication request to. At least one URL is expected.",
          "items": {
            "type": "string",
            "format": "uri",
            "description":  "Fully qualified URL of the ACS."
          },
          "minItems": 1
        },
        "three-ds-method-url": {
          "type": "string",
          "format": "uri",
          "description": "The ACS URL used for the 3DS Method flow."
        },
        "oreq-url": {
          "type": "string",
          "format": "uri",
          "description": "The ACS URL used for operation message exchange (OReq/ORes)."
        },
        "version-infos": {
          "type": "array",
          "description": "List of protocol versions supported by the ACS for the card BIN range, with their associated ACS Information Indicator, the 3DS Method URL.",
          "items": {
            "type": "object",
            "properties": {
              "protocol-version": {
                "$ref": "#/$defs/protocol-version",
                "description": "3DS protocol version supported by the ACS for the card BIN range."
              },
              "info-indicators": {
                "type": "array",
                "description": "List of ACS features supported for the card BIN range.",
                "items": {
                  "$ref": "#/$defs/acs-info-indicator"
                }
              }
            },
            "required": [
              "protocol-version"
            ]
          },
          "minItems": 1
        }
      },
      "required": [
        "reference-numbers",
        "areq-urls",
        "version-infos"
      ],
      "additionalProperties": false
    },
    "three-ds-servers-container": {
      "type": "object",
      "additionalProperties": {
        "type": "object",
        "$ref": "#/$defs/three-ds-server"
      },
      "description": "The 3DS Server configuration entries identified by the 3DS Server Operator ID as the key."
    },
    "three-ds-server" : {
      "type": "object",
      "properties": {
        "reference-numbers": {
          "type": "array",
          "description": "Set of unique identifier assigned to the 3DS Server by the EMVCo secretariat upon testing and approval.",
          "items": {
            "type": "string",
            "description": "Unique identifier assigned to the 3DS Server by the EMVCo secretariat upon testing and approval."
          },
          "minItems": 1,
          "uniqueItems": true
        },
        "oreq-url": {
          "type": "string",
          "format": "uri",
          "description": "The 3DS Server URL used for operation message exchange (OReq/ORes)."
        }
      },
      "required": [
        "reference-numbers"
      ],
      "additionalProperties": false
    },
    "acs-info-indicator": {
      "enum": ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "80", "81", "82", "83", "84", "85",
        "86", "87", "88", "89", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99"],
      "existingJavaType": "com.netcetera.ds.domain.message.pres.AcsInformationIndicatorEnum"
    },
    "protocol-version": {
      "enum": ["2.1.0", "2.2.0", "2.3.1"],
      "existingJavaType": "com.netcetera.ncacs.common.processor.v2.messages.enums.ProtocolVersionEnum"
    }
  }
}
`

export const dsConfigMinimalSnippet =
`
{
  "system-config": {
    "scheme-short-name": "MYSchema",
    "ds-reference-number": "ds-emvco-ref-number",
    "device-info-decryption-rsa-key-id": "device-info-private-encryption-key",
    "device-info-decryption-ec-key-id": "not-supported"
  },
  "three-ds-servers": {},
  "sdks": {},
  "bin-ranges": []
}
`
